module.exports = __webpack_public_path__ + "static/media/clemflix.14782aed.png";